import React, { useEffect, useState } from "react";
import {
    Box,
    Drawer,
    List,
    ListItem,
    ListItemText,
    TextField,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Toolbar,
    Button,
    Tooltip
} from "@mui/material";
import useApiManager from "../../utils/Api/apiManager";
import { Link } from "react-router-dom";
import { Modules } from "../../utils/enums";
import DeleteIcon from '@mui/icons-material/Delete';
import ConfirmationDialog from '../../components/ConfirmationDialog/ConfirmationDialog';


const DeleteRow = ({ hover }) => (
    <Box sx={{ position: 'relative', width: '20px', height: '22px' }}>
        {hover && <DeleteIcon />}
    </Box>
);

const folders = [
    "All Reports",
    "Lead Reports",
    "Contact Reports",
    "Account Reports",
    "Campaign Reports",
    "Deal Reports"
];

const ReportsPage = () => {
    const [reports, setReports] = useState([]);
    const { get, del } = useApiManager();
    const [hoveredRow, setHoveredRow] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [currentRow, setCurrentRow] = useState('');
    const [selectedFolder, setSelectedFolder] = useState(0); // 0 corresponds to "All Reports"

    const fetchReports = async () => {
        try {
            const data = await get("/reports");
            setReports(data);
        }
        catch (error) {
            console.error("Failed fetching reports: ", error);
        }
    };

    useEffect(() => {
        fetchReports();
        document.title = "Reports - iLead CRM";
    }, [])

    const handleOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleConfirmAction = () => {
        handleDelete();
        handleCloseDialog();
    };

    const handleDelete = async () => {
        try {
            const deletedRow = await del(`/reports/${currentRow.id}`);
            fetchReports();
        } catch (error) {
            console.error('Error deleting report:', error);
        }
    };

    // Map folder index to report type
    const folderToReportType = {
        1: 4, // "Lead Reports" -> type 4
        2: 2, // "Contact Reports" -> type 2
        3: 0, // "Account Reports" -> type 0
        4: 1, // "Campaign Reports" -> type 1
        5: 3, // "Deal Reports" -> type 3
    };

    // Filter reports based on selected folder
    const filteredReports = selectedFolder === 0
        ? reports
        : reports.filter(report => report.type === folderToReportType[selectedFolder]);


    return (
        <Box sx={{ display: "flex" }}>
            {/* Sidebar */}
            <Box
                sx={{
                    height: 'calc(100vh - 70px)',
                    width: 240,
                    bgcolor: "background.paper",
                    boxShadow: 1,
                    p: 2,
                    overflowY: "auto",
                }}
            >
                {/* <TextField fullWidth placeholder="Search Folder" size="small" sx={{ mb: 2 }} /> */}
                <List>
                    {folders.map((text, index) => (
                        <ListItem
                            button
                            key={index}
                            selected={selectedFolder === index}
                            onClick={() => setSelectedFolder(index)}
                        >
                            <ListItemText primary={text} />
                        </ListItem>
                    ))}
                </List>
            </Box>

            {/* Main Content */}
            <Box sx={{ flexGrow: 1, p: 3 }}>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
                    <Typography variant="h6">{folders[selectedFolder]}</Typography>
                    <Link to="/reports/create">
                        <Button>Create</Button>
                    </Link>
                </Box>

                {/* <TextField fullWidth placeholder="Search All Reports" size="small" sx={{ my: 2, bgcolor: "white" }} /> */}
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell width={10}>-</TableCell>
                                <TableCell>Report Name</TableCell>
                                <TableCell>Description</TableCell>
                                <TableCell>Type</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {filteredReports.map((report) => (
                                <TableRow key={report.id}
                                    onMouseEnter={() => setHoveredRow(report.id)}
                                    onMouseLeave={() => setHoveredRow(null)}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <Tooltip title="Delete">
                                        <TableCell sx={{ width: '20px', height: '22px', padding: '8px', cursor: 'pointer' }}
                                            onClick={() => {
                                                setCurrentRow(report);
                                                handleOpenDialog();
                                            }}>
                                            <DeleteRow hover={hoveredRow === report.id} />
                                        </TableCell>
                                    </Tooltip>
                                    <TableCell><Link to={`/reports/${report.id}`}>{report.name}</Link></TableCell>
                                    <TableCell>{report.description}</TableCell>
                                    <TableCell>{Modules[report.type].label}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <ConfirmationDialog
                    open={openDialog}
                    title="Confirm Action"
                    content="Are you sure you want to delete this item?"
                    onClose={handleCloseDialog}
                    onConfirm={handleConfirmAction}
                    confirmText="Confirm"
                    cancelText="Cancel"
                />
            </Box>
        </Box>
    );
};

export default ReportsPage;
